<script setup lang="ts">

import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { LoaderOverlay } from '@shared/ui/loaders'
import { BtnPrimary } from '@shared/ui/buttons'

import DisciplinePaymentRow from './DisciplinePaymentRow.vue'
import { useDisciplinePaymentSummary } from '../model/discipline-payment-summary.hook'

defineOptions({
  name: 'DisciplinePaymentSummary',
})

const ONE_TIME_COLUMNS = ['Lessons in package', 'Total price']
const INSTALLMENT_COLUMNS = [
  'Max pace',
  'Lessons per payment',
  'First payment',
  'Regular payment',
  'QTY',
  'Lessons in package',
  'Total price',
]

const {
  refIsOneTime,
  refIsCalculating,
  refIsGenerating,
  refCanGenerate,
  refOneTime,
  refInstallment,
  refCells,
  generate,
} = useDisciplinePaymentSummary()
</script>

<template>
  <div class="discipline-payment-summary">
    <div class="discipline-payment-summary__container">
      <AppTable
        class="rounded-table"
        :paginated="false"
      >
        <template #head>
          <AppTr>
            <AppTh
              v-for="column in (refIsOneTime ? ONE_TIME_COLUMNS : INSTALLMENT_COLUMNS)"
              :key="column"
              class="small regular"
            >
              {{ column }}
            </AppTh>
          </AppTr>
        </template>
        <template #body>
          <AppTr>
            <AppTd
              v-for="(value, index) in refCells"
              :key="index"
              :class="['small bold', { 'text-right': index === refCells.length - 1 }]"
            >
              {{ value }}
            </AppTd>
          </AppTr>
        </template>
      </AppTable>

      <div
        v-if="refIsOneTime"
        class="discipline-payment-summary__info"
      >
        <DisciplinePaymentRow
          :label="refOneTime.discount.label"
          :percent="refOneTime.discount.percent"
          :value="refOneTime.discount.amount"
        />
        <DisciplinePaymentRow
          label="Total"
          :value="refOneTime.total"
        />
      </div>
      <div
        v-else
        class="discipline-payment-summary__info"
      >
        <DisciplinePaymentRow
          v-if="refInstallment.trialDiscount"
          :label="refInstallment.trialDiscount.label"
          :percent="refInstallment.trialDiscount.percent"
          :value="refInstallment.trialDiscount.amount"
        />
        <DisciplinePaymentRow
          :label="refInstallment.discount.label"
          :percent="refInstallment.discount.percent"
          :value="refInstallment.discount.amount"
        />
        <DisciplinePaymentRow
          label="Total"
          :value="refInstallment.total"
        />
        <DisciplinePaymentRow
          label="First payment"
          :value="refInstallment.firstPayment"
          bold
        />
      </div>

      <LoaderOverlay v-if="refIsCalculating" />
    </div>
    <div class="discipline-payment-summary__submit">
      <BtnPrimary
        text="Generate payment order"
        :disabled="!refCanGenerate || refIsGenerating"
        @click="generate"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplinePaymentSummary.scss" />
